package com.platforma.chat_domain.model

import org.koin.core.scope.ScopeID

data class ChatDomain(
    val id: Long,
    val aiModelId: Long,
    val userId: Long,
    val name: String
)
